import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import Navigation from "../components/Navigation";
import SEO from "../components/SEO";

import HeroBgImg from "../assets/images/Me1.webp";
import PortraitImg from "../assets/images/Me2.webp";

function BioPage() {
  const prefersReduced = useReducedMotion();

  const fadeUp = (delay = 0) =>
    prefersReduced
      ? {}
      : {
          initial: { opacity: 0, y: 20 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, margin: "-60px" },
          transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1], delay },
        };

  return (
    <main className="bio-page">
      <SEO
        title="À propos"
        path="/bio"
        description="Alexandre Jack, photographe passionné basé à Villeurbanne. Son histoire, sa vision, son équipement."
      />
      <Navigation />

      {/* ── HERO ─────────────────────────────────────── */}
      <section className="bio-hero" aria-label="Alexandre Jack — Biographie">
        <div className="bio-hero__bg" aria-hidden="true">
          <img src={HeroBgImg} alt="" loading="eager" decoding="async" />
        </div>
        <div className="bio-hero__overlay" aria-hidden="true" />
        <div className="bio-hero__content">
          <p className="bio-hero__eyebrow">Photographe&nbsp;·&nbsp;Lyon</p>
          <h1 className="bio-hero__title">Alexandre<br />Jack</h1>
          <p className="bio-hero__tagline">Biographie</p>
        </div>
      </section>

      {/* ── BIO CONTENT ──────────────────────────────── */}
      <section className="bio-content" aria-label="À propos">
        <div className="bio-content__inner">

          <div className="bio-content__portrait">
            <motion.img
              src={PortraitImg}
              alt="Alexandre Jack, photographe à Lyon"
              loading="lazy"
              decoding="async"
              {...(prefersReduced
                ? {}
                : {
                    initial: { opacity: 0, x: -30 },
                    whileInView: { opacity: 1, x: 0 },
                    viewport: { once: true, margin: "-60px" },
                    transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] },
                  })}
            />
          </div>

          <div className="bio-content__text">
            <motion.p className="bio-content__label" {...fadeUp(0)}>
              À propos
            </motion.p>
            <motion.h2 className="bio-content__heading" {...fadeUp(0.06)}>
              Bio
            </motion.h2>
            <motion.p className="bio-content__body" {...fadeUp(0.12)}>
              Photographe autodidacte et passionné, Alexandre Hontcharouk a
              commencé la photographie car pour lui les moments de la vie sont
              précieux et qu'un jour ou l'autre le temps les effacera s'ils ne
              sont pas figés. Toujours à la recherche "du" cliché, des moments
              pleins de fougue, de sentiments, de vie... Le regard amoureux d'une
              jeune mariée, la première joie d'un enfant ou tout simplement la
              brume qui efface lentement l'image du présent...​ De vieilles
              légendes affirment que les photos peuvent voler l'âme des gens, il
              pense au contraire qu'elles permettent de faire perdurer ces
              émotions et de les rendre immortelles.
            </motion.p>

            <motion.h2 className="bio-content__heading" {...fadeUp(0.18)}>
              Expérience
            </motion.h2>
            <motion.p className="bio-content__body" {...fadeUp(0.24)}>
              Alexandre commence la photo en autodidacte en 2016 par des photos de
              paysage, de monuments, de nature... Puis poursuit par quelques
              sessions de portraits. Etant musicien, il décide de prendre
              l'appareil pour capturer l'énergie des différents groupes qu'il
              rencontre lors de ces concerts. Il fait ces débuts dans les mariages
              grâce à des amis qui ont décidé de s'unir pour la vie. Il a aussi
              une formation en photographie / event / mariage depuis 2016.
            </motion.p>
          </div>

        </div>
      </section>
    </main>
  );
}

export default BioPage;
